import { render, staticRenderFns } from "./retailRewards.vue?vue&type=template&id=67dc072b"
import script from "./retailRewards.vue?vue&type=script&lang=js"
export * from "./retailRewards.vue?vue&type=script&lang=js"
import style0 from "./retailRewards.vue?vue&type=style&index=0&id=67dc072b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports